import { render, staticRenderFns } from "./Deregister.vue?vue&type=template&id=7d4032dd&"
import script from "./Deregister.vue?vue&type=script&lang=js&"
export * from "./Deregister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports